module.exports = {"confirm":"Bestätigen Sie, wo Sie leben","hint":"Land, in dem Sie derzeit leben","other":"Anderes Land","residence":"Land auswählen","cta_confirm":"I confirm"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/residence.json
// module id = 511
// module chunks = 248 1669